import {FormControl, FormControlLabel, Radio, RadioGroup as MuiRadioGroup} from "@mui/material";
import React from "react";
import {RadioModel} from "../../../models/radio";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import Error from "../error/error";
import {observer} from "mobx-react";

interface RadioGroupProps {
    items: RadioModel[];
    label?: string;
    validatedValue: ValidatedValue<string | null>;
    testId: string;
    radioGroupClassName?: string;
}

function RadioGroup(props: RadioGroupProps) {
    return (
        <FormControl component="fieldset" className="radio-group" data-testid={props.testId}>
            <div className="radio-label">{props.label}</div>
            <MuiRadioGroup
                value={props.validatedValue.value}
                onChange={onChange}
                className={props.radioGroupClassName ? props.radioGroupClassName : ""}
            >
                {props.items.map((item: RadioModel, index: number) => {
                    return <FormControlLabel
                        key={`${props.testId}-${index}`}
                        data-testid={`${props.testId}-${item.value}`}
                        value={item.value}
                        label={item.label}
                        control={<Radio/>}
                        className={`${hasError() ? "has-error" : ""}${item.value === props.validatedValue.value ? " active" : ""}`}
                    />;
                })}
            </MuiRadioGroup>
            {hasError() && (
                <Error message={props.validatedValue.errorMessage}/>
            )}
        </FormControl>
    );

    function hasError() {
        return !!props.validatedValue.errorMessage;
    }

    function onChange(event: React.ChangeEvent<HTMLInputElement>) {
        props.validatedValue.clearValidation();
        props.validatedValue.setValue((event.target as HTMLInputElement).value);
    }
}

export default observer(RadioGroup);
